import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { FailureItem } from '@/types/accounting-sync';

interface FailuresResponse {
  items: FailureItem[];
  nextCursor: string | null;
}

export function useAccountingSyncFailures(opts?: { limit?: number; cursor?: string | null }) {
  const search = new URLSearchParams();
  if (opts?.limit != null) search.set('limit', String(opts.limit));
  if (opts?.cursor) search.set('cursor', opts.cursor);
  const qs = search.toString();
  const url = settingsEndpoints.accountingSyncFailures() + (qs ? `?${qs}` : '');

  return useApiQuery<FailuresResponse>({
    queryKey: [
      ...settingsKeys.accountingFailures(),
      opts?.limit ?? 'no-limit',
      opts?.cursor ?? 'first',
    ],
    queryFn: () => apiGet<FailuresResponse>(operationsClient, url),
    refetchInterval: 30_000,
    staleTime: 10_000,
    showErrorToast: false,
  });
}
